import { useState, useEffect } from 'react';
import { C } from './constants';

/**
 * Animated number counter.
 * Counts from 0 to `value` using requestAnimationFrame with easeInQuad.
 *
 * @param {number} value - Target number
 * @param {string} [color=C.text] - Text color
 * @param {number} [sz=48] - Font size in px
 */
export const AnimN = ({ value, color = C.text, sz = 48 }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    let start = null;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / 1000, 1);
      setCurrent(Math.round(p * p * value));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [value]);

  return (
    <span style={{
      fontSize: sz,
      fontWeight: 200,
      color,
      fontFamily: "'Inter', system-ui",
      letterSpacing: -2,
    }}>
      {current}
    </span>
  );
};
